import React from "react";
import Lottie from "lottie-react";
import ConditionalRender from "../ConditionalRender";
import styles from "./TNLoader.module.scss";
import loading from "../../Json/loading.json";
interface TNLoaderProps {
  isLoading: boolean;
}
const TNLoader = ({ isLoading }: TNLoaderProps) => {
  return (
    <ConditionalRender visible={isLoading}>
      <div className={styles.LoaderContainer}>
        <div
          style={{
            width: "240px",
            height: "240px",
            backgroundColor: "transparent", //"#00000073",
            borderRadius: "50%",
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            margin: "auto",
          }}
        >
          <Lottie loop={true} autoPlay={true} animationData={loading} />
          <h2 style={{ color: "#FFF", textAlign: "center" }}>Please wait...</h2>
        </div>
      </div>
    </ConditionalRender>
  );
};

export default TNLoader;
